import React, { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import ButtonFilled from "../../../../components/FormElements/ButtonFilled";
import branchActions from "../../../../store/branchStore/branchActions";
import Modal from "../../../../portals/Modal";
import PageHeader from "../../../../components/PageHeader";
import styles from './styles.module.scss';
import Select from "react-dropdown-select";
import TextField from "../../../../components/FormElements/TextField";
import Checkbox from "../../../../components/FormElements/Checkbox";
import branchApi from "../../../../store/branchStore/branchApi";

const initialState = {
    enabled: false,
    header: "",
    include_emoji: true,
    rate1: {
        bonus: 0,
        text: ""
    },
    rate2: {
        bonus: 0,
        text: ""
    },
    rate3: {
        bonus: 0,
        text: ""
    },
    rate4: {
        bonus: 0,
        text: ""
    },
    rate5: {
        bonus: 0,
        text: ""
    },
    time_after_message: [{ label: "", value: 0 }],
}

export default function ReviewRequest() {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [state, setState] = useState(initialState);
    const info = useSelector((s) => s.branchReducer.info);
    const [pending, setPending] = useState(false);
    const [errorModal, setErrorModal] = useState(false);
    const [enabled, setEnabled] = useState(false);

    const timeOptions = [
        { label: t('Reviews.10s'), value: 10 * 1000 },       // 10 секунд
        { label: t('Reviews.1h'), value: 1 * 60 * 60 * 1000 },       // 1 час
        { label: t('Reviews.2h'), value: 2 * 60 * 60 * 1000 },      // 2 часа
        { label: t('Reviews.3h'), value: 3 * 60 * 60 * 1000 },      // 3 часа
        { label: t('Reviews.5h'), value: 5 * 60 * 60 * 1000 },     // 5 часов
        { label: t('Reviews.1d'), value: 24 * 60 * 60 * 1000 },     // 1 день
        { label: t('Reviews.1w'), value: 7 * 24 * 60 * 60 * 1000 } // 1 неделя
    ];

    useEffect(() => {
        if (info && info.configuration.whatsapp_review) {
            const review = info.configuration.whatsapp_review;

            setState({
                ...state,
                enabled: info.configuration.access_toggles.whatsapp_review.enabled,
                header: review.header || "",
                include_emoji: review.include_emoji ?? true,
                rate1: {
                    bonus: review.rate1?.bonus || 0,
                    text: review.rate1?.text || "",
                },
                rate2: {
                    bonus: review.rate2?.bonus || 0,
                    text: review.rate2?.text || "",
                },
                rate3: {
                    bonus: review.rate3?.bonus || 0,
                    text: review.rate3?.text || "",
                },
                rate4: {
                    bonus: review.rate4?.bonus || 0,
                    text: review.rate4?.text || "",
                },
                rate5: {
                    bonus: review.rate5?.bonus || 0,
                    text: review.rate5?.text || "",
                },
                time_after_message: [
                    timeOptions.find((option) =>
                        option.value === review.time_after_message
                    ) || { label: "", value: 0 }
                ],
            });
        }
    }, [info]);

    const onSubmit = (e) => {
        e.preventDefault();

        if (info) {
            setPending(true);
            branchApi.putWhatsappReview(info.id, {
                ...state,
                rate1: {
                  ...state.rate1,
                  bonus: Number(state.rate1.bonus),
                },
                rate2: {
                  ...state.rate2,
                  bonus: Number(state.rate2.bonus),
                },
                rate3: {
                  ...state.rate3,
                  bonus: Number(state.rate3.bonus),
                },
                rate4: {
                  ...state.rate4,
                  bonus: Number(state.rate4.bonus),
                },
                rate5: {
                  ...state.rate5,
                  bonus: Number(state.rate5.bonus),
                },
                time_after_message: state.time_after_message[0].value,
            })
              .then(() => {
                  dispatch(branchActions.getBranch(info.id));
              })
              .finally(() => {
                  setPending(false);
              });
        }

    }

    return (
        <div className={styles.container}>
            <PageHeader title={t('Reviews.name')}>
                <p>{t('Reviews.description')}</p>
            </PageHeader>
            <form onSubmit={onSubmit}>
                <div style={{position: 'relative', display: 'flex', justifyContent: 'space-between'}}>
                    <div>
                        <div className={styles.p} style={{position: 'relative', marginTop: 0}}>
                            {t('Reviews.sendTime')}
                        </div>
                        <Select
                          style={{ height: 42, border: '1px solid #E7E7E6', borderRadius: '5px' }}
                          placeholder="1"
                          required
                          values={state.time_after_message}
                          options={timeOptions}
                          onChange={(v) => {
                              setState({...state, time_after_message: v});
                          }}
                        />
                    </div>
                    <div style={{ maxWidth: 500, width: '100%' }}>
                        <TextField
                          label={t('Reviews.title')}
                          required
                          value={state.header}
                          onChange={(e) => setState({ ...state, header: e.target.value })}
                        />
                    </div>
                </div>


                <div style={{position: 'relative', display: 'flex', flexDirection: 'column', gap: 15, marginTop: '1rem', marginBottom: '1rem'}}>
                    <div style={{ display: 'flex', gap: 16 }}>
                        <div style={{ flex: 1 }}>
                            <TextField
                              label={t('Reviews.mark5')}
                              value={state.rate5.text}
                              onChange={(e) => setState({ ...state, rate5: { ...state.rate5, text: e.target.value } })}
                            />
                        </div>
                        <div style={{ width: 220 }}>
                            <TextField
                              label={t('Reviews.bonusCount')}
                              type="number"
                              value={state.rate5.bonus}
                              onChange={(e) => setState({ ...state, rate5: { ...state.rate5, bonus: e.target.value } })}
                            />
                        </div>
                    </div>
                    <div style={{ display: 'flex', gap: 16 }}>
                        <div style={{ flex: 1 }}>
                            <TextField
                                label={t('Reviews.mark4')}
                                value={state.rate4.text}
                                onChange={(e) => setState({ ...state, rate4: { ...state.rate4, text: e.target.value } })}
                            />
                        </div>
                        <div style={{ width: 220 }}>
                            <TextField
                              label={t('Reviews.bonusCount')}
                              type="number"
                              value={state.rate4.bonus}
                              onChange={(e) => setState({ ...state, rate4: { ...state.rate4, bonus: e.target.value } })}
                            />
                        </div>
                    </div>
                    <div style={{ display: 'flex', gap: 16 }}>
                        <div style={{ flex: 1 }}>
                            <TextField
                              label={t('Reviews.mark3')}
                              value={state.rate3.text}
                            onChange={(e) => setState({ ...state, rate3: { ...state.rate3, text: e.target.value } })}
                            />
                        </div>
                        <div style={{ width: 220 }}>
                            <TextField
                              label={t('Reviews.bonusCount')}
                              type="number"
                              value={state.rate3.bonus}
                              onChange={(e) => setState({ ...state, rate3: { ...state.rate3, bonus: e.target.value } })}
                            />
                        </div>
                    </div>
                    <div style={{ display: 'flex', gap: 16 }}>
                        <div style={{ flex: 1 }}>
                            <TextField
                              label={t('Reviews.mark2')}
                              value={state.rate2.text}
                                onChange={(e) => setState({ ...state, rate2: { ...state.rate2, text: e.target.value } })}
                            />
                        </div>
                        <div style={{ width: 220 }}>
                            <TextField
                              label={t('Reviews.bonusCount')}
                              type="number"
                              value={state.rate2.bonus}
                              onChange={(e) => setState({ ...state, rate2: { ...state.rate2, bonus: e.target.value } })}
                            />
                        </div>
                    </div>
                    <div style={{ display: 'flex', gap: 16 }}>
                        <div style={{ flex: 1 }}>
                            <TextField
                              label={t('Reviews.mark1')}
                              value={state.rate1.text}
                                onChange={(e) => setState({ ...state, rate1: { ...state.rate1, text: e.target.value } })}
                            />
                        </div>
                        <div style={{ width: 220 }}>
                            <TextField
                              label={t('Reviews.bonusCount')}
                              type="number"
                              value={state.rate1.bonus}
                              onChange={(e) => setState({ ...state, rate1: { ...state.rate1, bonus: e.target.value } })}
                            />
                        </div>
                    </div>
                </div>

                <div style={{ margin: '1.5rem 0 0.5rem' }}>
                    <Checkbox
                      label={t('Reviews.includeEmoji') || 'Добавлять смайлик 😊 в конце сообщения'}
                      checked={state.include_emoji}
                      onChange={() => setState({ ...state, include_emoji: !state.include_emoji })}
                    />
                </div>

                <div style={{ display: 'flex', gap: 16, margin: '2rem 0' }}>
                    <Checkbox
                        label={t('switch_on')}
                        checked={state.enabled}
                        onChange={() => setState({ ...state, enabled: true })}
                    />
                    <Checkbox
                      checked={!state.enabled}
                      onChange={() => setState({ ...state, enabled: false })}
                      label={t('switch_off')}
                    />
                </div>


                <div style={{display: "flex", gap: "10px", alignItems: "center"}}>
                    <ButtonFilled
                      type="submit"
                      loading={pending}
                    >
                        {t('save')}
                    </ButtonFilled>
                </div>
            </form>
            <Modal
              open={errorModal} size="small"
              onClickClose={() => setErrorModal(false)}>
                <div className={styles.modal}>
                    <p>
                        {t('optionForbidden')} <br/>
                        {t('touchModerator')}
                    </p>
                    <div>
                        <ButtonFilled
                          onClick={() => setErrorModal(false)}
                        >{t('close')}</ButtonFilled>
                    </div>
                </div>
            </Modal>
        </div>
    )
}
